import { getData, postData } from "../baseApi";
import { jsonToForm, jsonToFormV2 } from "../utils";
import legacy from '../../utils/legacy';

const ESTATE_EXPLORE_API_ENDPOINT = {
    LIST: "/sale/filter_sale_list/",
    MAP: "/sale/filter_sale_map/",
    CENTER_PNU: "/polygon/get_pnu_by_latlng2/",
    CENTER_ADDRESS: "/detail/area_here2/",
    GET_REGION: "/sale/get_region/",
    GET_REGION_LATLNG:"/sale/get_region_latlng/",
    GET_REGION_BY_PNU:"/sale/get_region_by_pnu/",
};


export const requestEstateExploreList = (payload) => {
    const form = jsonToFormV2(payload);
    return postData(ESTATE_EXPLORE_API_ENDPOINT.LIST, form);
};

export const requestEstateExploreMap = (payload) => {
    const form = jsonToFormV2(payload);
    return postData(ESTATE_EXPLORE_API_ENDPOINT.MAP, form);
};

export const requestCenterPnu = (params) =>{
    return getData(legacy.server_by_hostname('polygon','get_pnu_by_latlng2/'), params);
}

export const requestCenterAddress = (params) =>{
    
    return getData(ESTATE_EXPLORE_API_ENDPOINT.CENTER_ADDRESS, params);
}

export const requestRegionByPnu = (params) =>{
    
    return getData(ESTATE_EXPLORE_API_ENDPOINT.GET_REGION_BY_PNU, params);
}

export const requestRegion = () => {
    return getData(ESTATE_EXPLORE_API_ENDPOINT.GET_REGION)
}

export const requestRegionLatLng = (params) => {
    return getData(ESTATE_EXPLORE_API_ENDPOINT.GET_REGION_LATLNG, params)
}

export const requestRegionCode = () =>{
    return 
}
